<template>
    <div id="app">
        <header>
            <div class="container">
                <h1>
                    Sorayume port
                </h1>
                <hnav></hnav>
            </div>
        </header>
        <transition name="fade">
        <router-view/>
        </transition>

        <footer>
            <small>&copy;miral</small>
        </footer>
    </div>
</template>

<script>
    import HeaderNav from '@/components/parts/NavHeader'

    export default {
        name: 'App',
        components: {
            hnav: HeaderNav
        },
    }
</script>

<style>
    [v-cloak] {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue